/* eslint-disable @typescript-eslint/no-explicit-any */
declare const wp: {
  apiFetch: (args: { path: string }) => Promise<any>;
};

export default function fetchIPAddress(): Promise<string> {
  return new Promise((resolve, reject) => {
    wp.apiFetch({ path: '/nbc/v1/ip' })
      .then((response) => {
        if ('string' === typeof response) {
          resolve(response);
        } else {
          reject(new Error('Expected a string response from /wp-json/nbc/v1/ip'));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
